import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { TabularSinkAdapter } from './tabular.sink.adapter';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';
import { MySqlSink } from 'app/model/pipeline/copysink/mysql.copysink';
import { ValueAdapter } from '../../value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MySqlSink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBatchTimeout: '*',
        writeBatchSize: '*',
        preCopyScript: '*',
        maxConcurrentConnections: '*',
        writeBehavior: '*'
    }
})
export class MySqlSinkAdapter extends CopySinkAdapter<MySqlSink, Model.MySqlSink> {
    protected override async _toResource(model: MySqlSink): Promise<Model.MySqlSink> {
        const result: Model.MySqlSink = {
            type: 'MySqlSink'
        };
        TabularSinkAdapter.toSinkResource(model, result);
        result.writeBehavior = ValueAdapter.toResource(model, MySqlSink.WRITE_BEHAVIOR);;
        return result;
    }

    protected override async _toModel(resource: Model.MySqlSink, owner: Activity): Promise<MySqlSink> {
        const result = Owned.create<MySqlSink>(Metamodel.modelFor(MySqlSink), owner);
        TabularSinkAdapter.toSinkModel(resource, result);
        ValueAdapter.toModel(result, MySqlSink.WRITE_BEHAVIOR, resource.writeBehavior);
        return result;
    }
}
